export const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const PLANS_FEATURES = {
  "sked-professional": ["approvals"],
  "sked-enterprise": ["approvals"],
  "sked-custom": ["approvals"],
  "sked-essentials": ["approvals"],
};
export const PLANS = Object.keys(PLANS_FEATURES);
